import { CreateForm, FormTemplateProps, FormFieldsData } from 'framework/form';
import useResumeService from 'domain/recruiting/candidate/Timeline/resume/resumeService';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import ResumeForm from 'domain/recruiting/candidate/Timeline/resume/form/ResumeForm';

interface CreateResumeFormProps extends FormTemplateProps {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
}

const CreateResumeForm = ({ submitFormFunc, onCancel, ...props }: CreateResumeFormProps) => {
  const { getValidationSchema } = useResumeService();

  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getValidationSchema} {...props}>
      <CreateTimelineItemLayout onCancel={onCancel}>
        <ResumeForm />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreateResumeForm;
